import { Button, Col, Modal, Row, Text } from 'components';
import { theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ComingSoon = ({ headerText, visible, closeModal }) => {
  const { t } = useTranslation();
  const isMobile = useSelector((state) => state.appState.isMobile);

  return (
    <Modal
      visible={visible}
      closeModal={closeModal}
      wid={isMobile ? '320px !important ' : 'auto !important'}
    >
      <Col pad="32px 42px" center wid="100%" maxWid="400px" marg="0 auto" boxSizing="border-box">
        <Col centerAll wid="100%">
          <Text h3 center>
            {headerText}
          </Text>

          <Row maxWid="296px" style={{ justifyContent: 'center', marginTop: '16px' }}>
            <Text center marg="18px 0 0">
              {t('common.featureComingSoon')}
            </Text>
          </Row>
        </Col>

        {/* Buttons on the same row */}
        <Row marg="30px 0 0" display="flex" justifyContent="space-between" gap="12px">
          <Button big bg={theme.SECONDARY} text={t('common.okay')} onClick={closeModal} />
        </Row>
      </Col>
    </Modal>
  );
};

export default ComingSoon;
